import config from '../../config';
import {
  UserDetailModel,
} from '../../model/ChallengeTeamDashboard.model';
import AxiosInterceptor from '../axiosInterceptor.service';
import { getDataFromSession } from '../../utill.func';
import AxiosHealthWellness from '../healthWellness';
import { BeginChallengeTeamDashboard } from '../../model/BeginChallengeTeamDashboard.model';
export const fetchBeginTeamDashboardDetail = async ({
  amwayNumber,
  partyId,
  challengeId,
}, selectedChallengeData = null) => {
  try {
    const response = await AxiosHealthWellness.get(
      `${config.API_URL}/hnw/challenge-external/team-full-data?eventId=${challengeId}&aboId=${amwayNumber}&partyId=${partyId}`,
    );
    const challengeData = getDataFromSession('challengeData') ?? selectedChallengeData?.find(el => el.eventId === challengeId);
    return new BeginChallengeTeamDashboard({
      ...response?.data,
      partyId,
      challengeData
    });
  } catch (error) {
    throw error;
  }
};

export const fetchBeginUserDetail = async (partyIds) => {
  try {
    const response = await AxiosInterceptor.post(
      `${config.API_URL}/customers/party-line-detail`,
      { partyIds: partyIds },
    );

    return new UserDetailModel(response?.data);
  } catch (error) {
    throw error;
  }
};


